export function timeToMinutes(timeStr) {
  if (!timeStr) return null;
  const [h, m] = timeStr.split(':').map(Number);
  return h * 60 + m;
}

export function addMinutesToTime(timeStr, delta) {
  if (!timeStr) return timeStr;
  const total = Math.max(0, Math.min(1439, timeToMinutes(timeStr) + delta));
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
